import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CliBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#050a0d',
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(2),
  fontFamily: theme.typography.fontFamily,

  boxShadow: `
      inset 0 0 12px rgba(0,0,0,0.9),
      0 0 12px rgba(125,211,199,0.08)
    `,

  position: 'relative',
}));
